import { ModalidadSeleccion } from './modalidad-seleccion.interface';
import { ModalidadSeleccionDto } from './modalidad-seleccion.dto';

export class ModalidadSeleccionMapper {
  static fromDto(dto: ModalidadSeleccionDto): ModalidadSeleccion {
    return {
      modalidadSelId: dto.modalidad_Sel_ID,
      codigo: dto.codigo,
      caracteristicas: dto.caracteristicas,
      estado: dto.estado
    };
  }

  static fromDtoList(dtoList: ModalidadSeleccionDto[]): ModalidadSeleccion[] {
    return dtoList.map(dto => this.fromDto(dto));
  }

  static toDto(model: ModalidadSeleccion): ModalidadSeleccionDto {
    return {
      modalidad_Sel_ID: model.modalidadSelId,
      codigo: model.codigo,
      caracteristicas: model.caracteristicas,
      estado: model.estado
    };
  }
}
